// extracted by mini-css-extract-plugin
module.exports = {"title":"DiscardNewModuleConfirmationDialogTheme_title__2ETcx","dialog":"DiscardNewModuleConfirmationDialogTheme_dialog__FWSXE"};